import { Component } from '@angular/core';
import { TipoConteudo as TipoConteudo } from 'src/app/model/arquivo.model';


@Component({
    selector: 'app-contratacao-lote-pesquisa',
    templateUrl: './contratacao-lote-pesquisa.component.html',
    standalone: false
})
export class ContratacaoLotePesquisaComponent {

  textoBotaoEnvio = 'Enviar lote de operações/liberações/amortizações';
  tooltipBotaoEnvio = 'Selecione esta opção para enviar um arquivo com operações, ' +
    'liberações ou amortizações antecipadas';
  tiposConteudo: TipoConteudo[] = [
    TipoConteudo.OPERACOES,
    TipoConteudo.LIBERACOES,
    TipoConteudo.AMORTIZACOES_ANTECIPADAS
  ];
}





